export default "__VITE_ASSET__3QVkNtX4__"